import { inject } from "@angular/core";

import {
  HttpRequest,
  HttpErrorResponse,
  HttpHandlerFn,
  HttpInterceptorFn,
} from "@angular/common/http";
import { throwError } from "rxjs";
import { catchError, switchMap } from "rxjs/operators";
import { OidcSecurityService } from "angular-auth-oidc-client";
import { Router } from "@angular/router";

export const httpInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
) => {
  const oidcSecurityService = inject(OidcSecurityService);
  const router = inject(Router);

  // Skip auth for public API endpoints
  const isPublicEndpoint = req.url.includes("/public") || req.url.includes("googleapis");

  if (isPublicEndpoint) {
    return next(req).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => error);
      }),
    );
  }

  return oidcSecurityService.getAccessToken().pipe(
    switchMap((token) => {
      if (token) {
        req = req.clone({
          headers: req.headers.set("Authorization", `Bearer ${token}`),
        });
      }
      return next(req);
    }),
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        // Only redirect if not on a public route (check hash for hash-based routing)
        const currentUrl = window.location.hash || window.location.pathname;
        if (!currentUrl.includes("/public")) {
          router.navigate(["/home"]);
        }
      }
      return throwError(() => error);
    }),
  );
};
